<template>
    <!-- SI TIENE LINK -->
    <a v-if="computedHref" :href="computedHref" target="_blank" rel="noopener noreferrer" class="contact-link">
        <div class="contact-card d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center contact-left">

                <div class="contact-icon">
                    <img v-if="icon" :src="icon" class="icon-img" />
                    <component v-else :is="iconComponent" />
                </div>

                <div class="contact-text">
                    <div class="contact-label">
                        {{ safeLabel }}
                    </div>
                    <div class="contact-value">
                        {{ value }}
                    </div>
                </div>

            </div>

            <div class="contact-arrow">
                <ArrowRight />
            </div>

        </div>
    </a>

    <!-- SI NO TIENE LINK -->
    <div v-else class="contact-link disabled">
        <div class="contact-card d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center contact-left">

                <div class="contact-icon">
                    <component :is="iconComponent" />
                </div>

                <div class="contact-text">
                    <div class="contact-label">
                        {{ safeLabel }}
                    </div>
                    <div class="contact-value">
                        {{ value }}
                    </div>
                </div>

            </div>

            <div class="contact-arrow">
                <ArrowRight />
            </div>

        </div>
    </div>
</template>

<script>
import { Linkedin, MessageCircle, Globe, Music, Mail, Youtube, Twitter, ArrowRight } from 'lucide-vue-next';

export default {
    name: 'ContactLink',

    components: {
        Linkedin,
        MessageCircle,
        Globe,
        Music,
        Mail,
        Youtube,
        Twitter,
        ArrowRight
    },

    props: {
        type: String,
        label: String,
        value: String,
        href: String,
        icon: String
    },

    computed: {

        safeLabel() {
            if (this.label && this.label !== 'null') return this.label

            const labels = {
                whatsapp: 'WhatsApp',
                email: 'Correo',
                linkedin: 'LinkedIn',
                web: 'Sitio Web',
                telefono: 'Teléfono',
                youtube: 'YouTube',
                x: 'X (Twitter)'
            }

            return labels[this.normalizedType] || this.normalizedType || 'Contacto'
        },

        normalizedType() {
            return (this.type || '').toLowerCase()
        },

        computedHref() {
            const val = this.href || this.value
            if (!val) return null

            const clean = String(val).trim()
            const type = this.normalizedType

            if (type === 'whatsapp') {
                if (clean.startsWith('http')) return clean

                if (/^\d{9}$/.test(clean)) {
                    return `https://wa.me/51${clean}`
                }

                return null
            }

            if (type === 'linkedin') {
                if (clean.toLowerCase().includes('url')) return null
                if (clean.includes(' ')) return null

                return clean.startsWith('http')
                    ? clean
                    : `https://linkedin.com/in/${clean}`
            }

            if (type === 'web' || type === 'globe') {
                return clean.startsWith('http')
                    ? clean
                    : `https://${clean}`
            }

            if (type === 'email') {
                return clean.includes('@') ? `mailto:${clean}` : null
            }

            if (type === 'telefono') {
                return /^\d+$/.test(clean) ? `tel:${clean}` : null
            }

            if (type === 'spotify') {
                return clean.startsWith('http')
                    ? clean
                    : `https://open.spotify.com/${clean}`
            }

            if (type === 'youtube') {
                return clean.startsWith('http')
                    ? clean
                    : `https://youtube.com/${clean}`
            }

            if (type === 'x' || type === 'twitter') {
                return clean.startsWith('http')
                    ? clean
                    : `https://x.com/${clean}`
            }

            return null
        },

        iconComponent() {
            const val = this.value || ''
            const type = this.normalizedType

            if (type === 'linkedin') return Linkedin
            if (type === 'whatsapp' || /^\d+$/.test(val)) return MessageCircle
            if (type === 'email' || val.includes('@')) return Mail
            if (type === 'spotify') return Music
            if (type === 'youtube') return Youtube
            if (type === 'x' || type === 'twitter') return Twitter

            return Globe
        }
    }
};
</script>

<style scoped>

.contact-arrow svg {
  width: 14px;
  height: 14px;
}

.contact-link {
    text-decoration: none;
    color: inherit;
}

.contact-card {
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid #e8e8e8;
    background: #ffffff;
    transition: all 0.18s ease;
}

.contact-card:hover {
    background: #f7f9fb;
    border-color: #4d9ec1;
}

.contact-left {
    gap: 8px;
}

.contact-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #f0f6f9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4d9ec1;
    transition: all 0.2s ease;
}

.contact-icon svg {
    width: 16px;
    height: 16px;
}

.contact-card:hover .contact-icon {
    background: #4d9ec1;
    color: white;
}

.contact-text {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
}

.contact-label {
    font-size: 12.5px;
    font-weight: 600;
    color: #262626;
}

.contact-value {
    font-size: 11px;
    color: #888;
}

.contact-arrow {
    font-size: 14px;
    color: #bbb;
    transition: all 0.2s ease;
}

.contact-card:hover .contact-arrow {
    transform: translateX(3px);
    color: #4d9ec1;
}
</style>